import { Avatar } from '../../shell/Avatar';
import type { ActivityEntry } from '../data/types';
import { relativeTime } from '../format';
import { PreviewBadge } from './ServiceCard';

function Line({ entry, now, size }: { entry: ActivityEntry; now: Date; size: number }) {
  return (
    <li className="hm-act__row">
      <Avatar initial={entry.initial} size={size} tone={entry.tone} />
      <span className="hm-act__text">
        {entry.before}
        {entry.link ? <span className="hm-act__link">{entry.link}</span> : null}
        {entry.after}
      </span>
      <time className="hm-act__time" dateTime={entry.at.toISOString()}>
        {relativeTime(entry.at, now)}
      </time>
    </li>
  );
}

/** « Activité de la famille » (bureau) : carte avec une ligne par action. Données d'exemple tant que l'activité n'est pas fournie. */
export function ActivityCard({ entries, now }: { entries: ActivityEntry[]; now: Date }) {
  return (
    <section className="hm-card hm-card--activity" aria-labelledby="hm-activity">
      <header className="hm-card__head">
        <h2 className="hm-card__title" id="hm-activity">Activité de la famille</h2>
        <PreviewBadge />
      </header>
      <ul className="hm-act">
        {entries.map((e) => (
          <Line key={e.id} entry={e} now={now} size={36} />
        ))}
      </ul>
    </section>
  );
}

/** « ACTIVITÉ » (mobile) : surtitre puis lignes à plat, sans carte. */
export function ActivityList({ entries, now }: { entries: ActivityEntry[]; now: Date }) {
  return (
    <section aria-labelledby="hm-activity-m">
      <h2 className="hm-eyebrow hm-eyebrow--row" id="hm-activity-m">
        Activité <PreviewBadge />
      </h2>
      <ul className="hm-act hm-act--flat">
        {entries.slice(0, 2).map((e) => (
          <Line key={e.id} entry={e} now={now} size={36} />
        ))}
      </ul>
    </section>
  );
}
